export default {
  name: 'admin',
  translationKey: 'admin-module',
  routePrefix: 'admin',
  routeNamePrefix: 'admin',
}
